import React from 'react'
import {  Box, Heading, Text ,Image} from '@chakra-ui/core'
import { ICollectionProduct } from '@engyalo/storefront-types'


export const SoupProductItem: React.FC<ICollectionProduct> = ({
    product,
    currencyPrefix,
}: ICollectionProduct) => {
    return (
       <Box width="100%" px="8px" >
           <Box boxShadow="0 0 7px -2px rgb(0,0,0,40%)" backgroundColor="white" borderRadius="15px" display="flex" overflow="hidden">
                <Image src={product?.imageURL?.[0] ?? ''} alt="Product Image" 
                height="100px" objectFit="contain"
                />

                <Box p="6px" flex="1" d="flex" flexDir="column" justifyContent="space-between">
                    <Box mb="0.5rem">
                        <Heading as="h3" fontSize="1.5rem" fontWeight="500" lineHeight="1" color="primary.100" pb="0.5rem" >
                                    {product.name}
                        </Heading>
                        <Text fontSize="1rem" fontWeight="100" pt="0.5rem" color="primary.100" lineHeight="1" >
                            {product.description}
                        </Text>
                    </Box>
                    <Text fontSize="1.3rem" color="primary.200" lineHeight="1.3" fontWeight="800">
                            {currencyPrefix} {product.price}
                    </Text>
                </Box>
    
           </Box>
        </Box>
    )
}